<template>
  <Layout>
    <LayoutBody mode="horizontal" class="page-body--row">
      <LayoutContent class="content-body">
        <Panel class="report_content">
          <strong> {{ `${filterPaperName(nameTrans)} ${$t('hsk_report')}` }}</strong>
          <div class="progress-content">
            <ProgressBar
              :width="230"
              :stroke-width="8"
              :value="value"
              :color="computedColor"
              :rateRadius="0.6"
            >
              <div class="score">
                <span :style="{ color: computedFontColor }">{{
                  Math.round(Number(score)) || 0
                }}</span>
                <span>{{ `/${totalScore}` }}</span>
              </div>
              <div class="standard">
                {{ $t('hsk_qualified_point', { points: scoreQualified }) }}
              </div>
              <div
                class="tryAgain"
                @click="tryAgain"
                v-if="isMarked == 2 && $route.query.examinationType != 4"
              >
                {{ $t('hsk_test_again') }}
              </div>
            </ProgressBar>
          </div>
          <div v-if="isMarked != 2" class="report-tips">
            <div style="font-size: 16px;" v-if="levelId == 8 || levelId == 13 || levelId == 14">
              {{ $t('mark_report_tips_hskk') }}
            </div>
            <div v-else>
              {{ $t('mark_report_tips', { markNumberDesc }) }}
            </div>
          </div>
          <div
            class="download_tips"
            v-if="isMarked != 2 || Math.round(Number(score)) / totalScore < 0.6"
          >
            {{ $t('download_tips') }}
          </div>
          <button
            class="btn-yellow btn-submit"
            @click="submitCertificate"
            :disabled="isMarked != 2"
            v-if="Math.round(Number(score)) / totalScore >= 0.6"
          >
            {{ $t('get_official_mock_certificate') }}
          </button>
          <div class="report_answer_list" v-for="(item, index) in questionAnswers" :key="index">
            <div class="title">
              <SvgIcon :type="`${item.name}ing`" class="icon-20"></SvgIcon>
              <div style="margin-left: 15px">{{ findSegmentCodeStr(item.name) }}</div>
              <p class="click-tips">{{ $t('click_tips') }}</p>
            </div>
            <div v-for="(part, i) in item.dataInfo" :key="i">
              <div class="part">
                {{ $t('hsk_part1', { part: part.name }) }}
                {{ `${$t('hsk_accuracy1')}: ${part.rightTate}` }}
              </div>
              <div class="item-circle">
                <span
                  v-for="(card, j) in part.dataInfo"
                  :key="j"
                  :class="[
                    card.judge ? 'right' : 'error',
                    isMarked != 2 && markIdList.includes(card.questionId) ? 'unmarked' : '',
                  ]"
                  @click="checkExam(card.questionId)"
                  >{{ card.questionId }}</span
                >
              </div>
            </div>
          </div>
        </Panel>
        <CertificateDialog
          :editCertificateDialogVisible="editCertificateDialogVisible"
          @close="closeCertificateDialog"
          @save="saveCertificateDialog"
          v-if="editCertificateDialogVisible"
        ></CertificateDialog>
      </LayoutContent>
    </LayoutBody>
  </Layout>
</template>

<script>
import ProgressBar from '@/components/ui/progress-bar'
import CertificateDialog from '@/components/hsk/common/certificatesDialog.vue'
import { apiRequest } from '@/serves/http'
import SvgIcon from '@/components/SvgIcon.vue'
import { MARK_RESULT_TYPE } from '@/config'
import { mapState } from 'vuex'
import analytics from '@/utils/AnalyticsCenter'
import { getTime } from '@/utils/hskTypeName'
import { mapMutations } from 'vuex'
import { mixinMixpanel } from '@/mixins'

export default {
  components: {
    ProgressBar,
    SvgIcon,
    CertificateDialog,
  },
  mixins: [mixinMixpanel],
  data() {
    return {
      value: 0,
      partIcon: {
        listen: '',
        read: '',
        write: '',
        translation: '',
        speaking: '',
      },
      totalScore: '', // 试卷总分
      score: '', //用户总得分
      scoreQualified: '', // 合格分数
      questionAnswers: [],
      nameTrans: '',
      // 资源前缀
      rootPath: '',
      isMarked: 2, // 0 未批改 1批改中 2已批改
      markNumberDesc: '',
      markIdList: [], // 需要批改的题ID
      loadIndex: '',
      editCertificateDialogVisible: false,
      levelId: 1,
    }
  },
  async mounted() {
    this.loadIndex = window.layer.load(3)
    await this.getReportList()
    this.getCardList()
  },
  computed: {
    computedShowDownLoad() {
      if (this.levelId == 12) {
        return Number(this.score) >= this.scoreQualified
      } else {
        return Math.round(Number(this.score)) / this.totalScore >= 0.6
      }
    },
    ...mapState({
      role: (state) => state.user.role,
    }),
    computedColor: function () {
      if (this.levelId == 12) {
        return [
          { color: '#FF858C', percentage: 0.63 },
          { color: '#62C1A5', percentage: 1 },
        ]
      }
      return [
        { color: '#FF858C', percentage: 0.6 },
        { color: '#62C1A5', percentage: 1 },
      ]
    },
    computedFontColor: function () {
      let color
      let passScore = this.totalScore * 0.6
      if (this.levelId == 12) {
        passScore = this.scoreQualified
      }
      if (this.score >= passScore) {
        color = '#62C1A5'
      } else {
        color = '#FF858C'
      }
      return color
    },
    isCanTryAgain() {
      return this.role === 'admin' || this.role === 'editor'
    },
  },
  methods: {
    ...mapMutations({
      UPDATE_CERTIFICATES_MESSAGE: 'user/UPDATE_CERTIFICATES_MESSAGE',
    }),
    filterPaperName(nameTrans) {
      if (!nameTrans) {
        return ''
      }
      let language = localStorage.getItem('language')
      if (language === 'zh') {
        language = 'cn'
      }

      return typeof nameTrans === 'string' ? JSON.parse(nameTrans)[language] : nameTrans[language]
    },
    // 获取报告基本信息
    getReportList() {
      let dateTime = getTime(new Date())
      if (!this.$route.query.paperId || !this.$route.query.examinationType) return
      return new Promise((resolve) => {
        let params = {
          paperId: this.$route.query.paperId,
          examinationType: this.$route.query.examinationType,
        }
        if (this.$route.query.examination_id) {
          Object.assign(params, { examination_id: this.$route.query.examination_id })
        }
        utilV2.postData(
          ApiPath.hsk_get_paperReport,
          params,
          (data) => {
            this.levelId = data.levelId
            this.totalScore = data.totalScore
            this.score = data.score
            this.scoreQualified = data.scoreQualified
            this.value = this.score / this.totalScore
            this.nameTrans = data.name_trans
            this.rootPath = data.resource_url.slice(0, -4) + '/'
            this.isMarked = data.markStatus
            //试卷提交埋点
            let subdata = this.$route.query
            let mixpanelParams = {
              people_id: this.peopleId,
              unlimited: this.unlimited,
              exam_type: this.currentLevelActive.level_name,
              success_submitted: true,
              paper_type: subdata.name,
              mark: Number(this.score),
              final: true,
            }
            analytics.logEvent('hskweb_mocksubmit_click', mixpanelParams)
            console.log('获取报告信息', data)
            resolve()
          },
          (res) => {
            //试卷提交失败埋点
            let subdata = this.$route.query
            let mixpanelParams = {
              people_id: this.peopleId,
              unlimited: this.unlimited,
              exam_type: this.currentLevelActive.level_name,
              success_submitted: false,
              paper_type: subdata.name,
              mark: Number(this.score || 0),
              final: true,
            }
            analytics.logEvent('hskweb_mocksubmit_click', mixpanelParams)
          },
          null,
          { showLoading: false }
        )
      })
    },
    // 获取答题卡信息
    getCardList() {
      const { query } = this.$route
      if (JSON.stringify(query) === '{}') return
      utilV2.postData(
        ApiPath.hsk_get_list_answer,
        { ...query },
        (res) => {
          // 拉取json 数据 获取题目配分
          utilV2.getJSON(
            `${this.rootPath}index.json`,
            (data) => {
              this.resourceList = []
              // 重新组装索引页数据
              let tempArr = []
              let Data = []
              for (let i = 0; i < data.items.length; i++) {
                if (tempArr.indexOf(data.items[i].segment_code) === -1) {
                  Data.push({
                    name: data.items[i].segment_code,
                    nameStr: this.findSegmentCodeStr(data.items[i].segment_code),
                    dataInfo: [data.items[i]],
                  })
                  tempArr.push(data.items[i].segment_code)
                } else {
                  for (let j = 0; j < Data.length; j++) {
                    if (Data[j].name == data.items[i].segment_code) {
                      Data[j].dataInfo.push(data.items[i])
                      break
                    }
                  }
                }
              }
              console.log(Data)
              // 取出所有题型的题目 再次重新拼凑
              let quesList = []
              // 预存需要批改的题型
              let markList = []
              Data.forEach((itemData) => {
                itemData.dataInfo.forEach((data) => {
                  console.log('data', data)
                  quesList.push(this.apiRequest(data.topic_items))
                  if (Object.values(MARK_RESULT_TYPE).includes(data.topic_type)) {
                    markList.push({
                      segment_code: data.segment_code,
                      part_code: data.part_code,
                      topic_type: data.topic_type,
                    })
                  }
                })
              })
              Promise.all(quesList).then((resData) => {
                // 扁平化数组并去掉例题
                const filterList = resData.flat().filter((item) => !item.is_example)
                console.log('filterList', filterList)
                let fnlData = []
                filterList.forEach((item) => {
                  if (item.questions) {
                    // 如果是套题的情况
                    item.questions
                      .filter((i) => !i.is_example)
                      .forEach((eg) => {
                        fnlData.push(eg)
                      })
                  } else {
                    fnlData.push(item)
                  }
                })
                console.log(fnlData, 'fnlData')
                let questionAnswers = res.questionAnswers.map((item) => {
                  console.log(item.questionId, item)
                  return {
                    ...item,
                    standardScore: fnlData.find((j) => j.index == item.questionId).score,
                    judge:
                      item.scores / fnlData.find((j) => j.index == item.questionId).score >= 0.8
                        ? 1
                        : 0, // 重新改变judge规则
                  }
                })
                // 重新组装成想要的数据
                const segmentCode = this.mergeData(questionAnswers, 'segmentCode')
                console.log(segmentCode)

                let markAllList = []
                markList.forEach((item) => {
                  markAllList.push(
                    segmentCode
                      .find((code) => code.name == item.segment_code)
                      .dataInfo.filter((s) => {
                        if (item.topic_type == 'lr') {
                          let obj = fnlData.find((e) => e.index == s.questionId)
                          // retrun
                          if (obj.content_tk) {
                            return true
                          }
                          return
                        }

                        return s.partCode == item.part_code
                      })
                  )
                })

                let markFinalList = markAllList?.flat()?.sort((a, b) => a.questionId - b.questionId)

                this.markIdList = markFinalList.map((item) => item.questionId)

                this.markNumberDesc =
                  markFinalList.length > 1
                    ? `${markFinalList[0].questionId}-${
                        markFinalList[markFinalList.length - 1].questionId
                      }`
                    : markFinalList[0]?.questionId

                const that = this
                segmentCode.forEach((item) => {
                  item.dataInfo = that.mergeData(item.dataInfo, 'partCode')
                  item.dataInfo.forEach((part, index) => {
                    let rightNum = 0
                    let quesNum = 0
                    part.dataInfo.forEach((card) => {
                      if (['write', 'translation', 'speaking'].includes(card.segmentCode)) {
                        rightNum += card.scores
                        quesNum += card.standardScore
                      } else {
                        if (card.judge) {
                          rightNum++
                        }
                        quesNum++
                      }
                    })
                    let isIncludeMark = part.dataInfo.some((item) =>
                      this.markIdList.includes(item.questionId)
                    )
                    let rate =
                      this.isMarked != 2 && isIncludeMark
                        ? `--% (${this.$t('mark_un_correct')})`
                        : `${((rightNum / quesNum) * 100).toFixed(0)}%`
                    item.dataInfo[index].rightTate = rate //拼接正确率
                  })
                })
                this.questionAnswers = segmentCode
                window.layer.close(this.loadIndex)
              })
            },
            null,
            { showLoading: false }
          )
        },
        null,
        { showLoading: false }
      )
    },
    // 请求每个题的json数据
    apiRequest(name) {
      return new Promise(async (resolve) => {
        let result
        await utilV2.getJSON(
          `${this.rootPath + name}`,
          (data) => {
            result = data.items
          },
          null,
          { showLoading: false }
        )
        resolve(result)
      })
    },
    findSegmentCodeStr(code) {
      let codeStr = ''
      switch (code) {
        case 'listen':
          codeStr = this.$t('hsk_listen_name')
          break
        case 'read':
          codeStr = this.$t('hsk_read_name')
          break
        case 'write':
          codeStr = this.$t('hsk_write_name')
          break
        case 'translation':
          codeStr = this.$t('Traduction')
          break
        case 'speaking':
          codeStr = this.$t('speaking')
          break
        default:
          break
      }
      return codeStr
    },
    // 实现多层数组嵌套抽离
    mergeData(questionAnswers, code) {
      let tempArr = []
      let Data = []
      for (let i = 0; i < questionAnswers.length; i++) {
        if (tempArr.indexOf(questionAnswers[i][code]) === -1) {
          Data.push({
            name: questionAnswers[i][code],
            dataInfo: [questionAnswers[i]],
          })
          tempArr.push(questionAnswers[i][code])
        } else {
          for (let j = 0; j < Data.length; j++) {
            if (Data[j].name == questionAnswers[i][code]) {
              Data[j].dataInfo.push(questionAnswers[i])
              break
            }
          }
        }
      }
      return Data
    },
    // 再试一次
    tryAgain() {
      // 检查试卷是否下架
      apiRequest
        .get(`${ApiPath.hsk_paper_status}?paper_id=${this.$route.query.paperId}`)
        .then((data) => {
          if (data.data == 2 && !this.isCanTryAgain) {
            this.$message({ type: 'error', message: this.$t('test_paper_office') })
          } else {
            this.$router.replace({
              name: 'Introduce',
              query: {
                ...this.$route.query,
                examination_id: '',
                paperStatus: null,
                examinationType: this.$route.query.examinationType,
              },
            })
          }
        })
    },
    //点击题号进入答题页查看单题结果
    checkExam(questionId) {
      let pageName = 'Simulation'
      if (this.levelId == 12) {
        pageName = 'SimulationHigh'
      }
      let hsk3levelList = [15, 16, 17, 18, 19, 20]
      if (hsk3levelList.includes(this.levelId)) {
        pageName = 'SimulationTri'
      }
      // hskk页面
      if ([8, 13, 14].includes(this.levelId)) {
        pageName = 'SimulationHskk'
      }
      this.$router.push({
        name: pageName,
        query: {
          ...this.$route.query,
          examinationType: this.$route.query.examinationType,
          currentQuesIndex: questionId,
          paperStatus: 1,
          report: true,
        },
      })
    },
    // 保存证书信息
    saveCertificateDialog(params) {
      let paperParams = {
        paper_id: +this.$route.query.paperId,
        examination_type: +this.$route.query.examinationType,
      }
      if (this.$route.query.examination_id) {
        Object.assign(params, { examination_id: this.$route.query.examination_id })
      }
      apiRequest
        .post(ApiPath.hsk_certificate_create, { ...params, ...paperParams }, { loading: true })
        .then(() => {
          this.UPDATE_CERTIFICATES_MESSAGE(params)
          this.editCertificateDialogVisible = false
        })
        .catch((err) => {
          this.$message({
            message: err,
            type: 'error',
          })
        })
    },
    // 关闭弹窗
    closeCertificateDialog() {
      this.editCertificateDialogVisible = false
    },
    // 打开弹窗
    submitCertificate() {
      this.editCertificateDialogVisible = true
    },
  },
}
</script>

<style lang="scss" scoped>
.report_content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1000px;
  margin: 0 auto;
  strong {
    margin: 30px auto 20px;
    font-weight: 500;
    font-size: 24px;
    color: #2c2f46;
  }
  .progress-content {
    height: 174px;
    position: relative;
    .score {
      font-size: 32px;
      font-weight: bold;
    }
    .standard {
      font-size: 11px;
      font-weight: 400;
      color: rgba(196, 201, 211, 1);
      margin-top: 11px;
    }
    .tryAgain {
      display: inline-block;
      min-height: 24px;
      min-width: 75px;
      border-radius: 12px;
      line-height: 22px;
      font-size: 11px;
      font-weight: 400;
      color: rgba(63, 70, 81, 1);
      border: 1px solid rgba(215, 219, 222, 1);
      margin: 15px 0 19px 0;
      padding: 0 5px;
      cursor: pointer;
    }
    &_tips {
      position: absolute;
      width: 34px;
      height: 22px;
    }
  }
  .report-tips {
    width: 398px;
    min-height: 40px;
    color: #b33939;
    font-weight: 400;
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    margin-top: 7px;
  }
  .download_tips {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    /* identical to box height, or 125% */
    color: #000000;
  }
  .report_answer_list {
    width: 940px;
    margin: 40px 0 0 0;
    .title {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-family: PingFangSC-Medium, Inter;
      font-weight: 600;
      color: #2c2f46;
      line-height: 16px;
      margin-bottom: 10px;
      height: 44px;
      background: #fafafb;
      border-radius: 6px;
      padding: 0 15px;
      .click-tips {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 17px;
        color: #b5b5be;
        margin-left: 20px;
      }
    }
    .part {
      font-size: 14px;
      font-family: PingFangSC-Regular, Inter;
      font-weight: 400;
      color: #b5b5be;
      padding-left: 18px;
      display: flex;
      align-items: center;
      border-radius: 4px;
    }
    .item-circle {
      margin: 20px 18px;
      cursor: pointer;
      .right {
        // border-color: #09cba0;
        color: #09cba0;
        background-color: #fafafb;
      }
      .error {
        // border-color: #fc5a5a;
        color: #fc5a5a;
        background-color: #fafafb;
      }
      .unmarked {
        color: #b5b5be;
      }
      span {
        display: inline-flex;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        border: 1px solid #fff6ee;
        margin-right: 12px;
        margin-bottom: 12px;
        font-size: 16px;
        font-family: PingFangSC-Medium, Inter;
        font-weight: 500;
        justify-content: center;
        align-items: center;
        line-height: 20px;
      }
    }
  }
  .btn-submit {
    width: 320px;
    height: 52px;
    background: #faae56;
    border-radius: 4px;
    color: #ffffff;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    margin-top: 10px;
    position: relative;
    z-index: 10;
  }
  button[disabled='disabled'] {
    background: #e7e7ed;
    cursor: not-allowed;
  }
}
</style>
